import React from 'react';
import { MdWifiOff } from 'react-icons/md';

export default function NoInternet() {
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f9fafb',
      color: '#333',
      textAlign: 'center',
      padding: 20,
    }}>
      <MdWifiOff size={120} color="#e53e3e" />
      <h1 style={{ marginTop: 20, fontSize: '2rem' }}>No Internet Connection</h1>
      <p style={{ maxWidth: 400, marginTop: 10, fontSize: '1.1rem' }}>
        Please check your network settings and try again.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: 30,
          padding: '10px 30px',
          fontSize: '1rem',
          backgroundColor: '#3182ce',
          color: 'white',
          border: 'none',
          borderRadius: 5,
          cursor: 'pointer',
        }}
      >
        Retry
      </button>
    </div>
  );
}